import React, { useState } from 'react';
import { animalesAPI } from '../../services/api';

const GenealogyCard = ({ label, animalId, navigate }) => {
  const [parent, setParent] = useState(null);
  React.useEffect(() => {
    animalesAPI.getById(animalId).then(res => setParent(res.data?.animal)).catch(() => {});
  }, [animalId]);
  if (!parent) return <div className="bg-white rounded-lg p-3 text-sm text-gray-400">Cargando {label}...</div>;
  return (
    <div className="bg-white rounded-lg p-3 border border-indigo-100 cursor-pointer hover:border-indigo-300 transition"
      onClick={() => navigate(`/animales/${animalId}`)} data-testid={`genealogia-${label.toLowerCase()}`}>
      <p className="text-xs text-indigo-600 font-semibold mb-1">{label}</p>
      <p className="font-bold text-gray-900">VID: {parent.VID}</p>
      <p className="text-xs text-gray-500">IDE: {parent.IDE || '-'} | {parent.raza} | {parent.categoria?.replace('_', ' ')}</p>
    </div>
  );
};

export const GenealogiaSection = ({ animal, navigate, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [madreVid, setMadreVid] = useState('');
  const [padreVid, setPadreVid] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const abrir = async () => {
    setError('');
    let m = '', p = animal.padre_externo || '';
    try {
      if (animal.madre_id) m = (await animalesAPI.getById(animal.madre_id)).data?.animal?.VID || '';
      if (animal.padre_id) p = (await animalesAPI.getById(animal.padre_id)).data?.animal?.VID || '';
    } catch { /* se deja vacio */ }
    setMadreVid(m);
    setPadreVid(p);
    setEditing(true);
  };

  const guardar = async () => {
    setSaving(true); setError('');
    try {
      const payload = {};
      if (madreVid.trim() || animal.madre_id) payload.madre_vid = madreVid.trim();
      if (padreVid.trim() || animal.padre_id || animal.padre_externo) payload.padre_vid = padreVid.trim();
      if (Object.keys(payload).length === 0) { setEditing(false); return; }
      await animalesAPI.update(animal.id, payload);
      setEditing(false);
      onSaved?.();
    } catch (e) {
      setError(e.response?.data?.detail || 'No se pudo guardar');
    } finally { setSaving(false); }
  };

  const tiene = animal.madre_id || animal.padre_id || animal.padre_externo;

  return (
    <div className="mt-6 p-4 bg-indigo-50 border border-indigo-200 rounded-lg" data-testid="genealogia-section">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-indigo-800">Genealogia</h3>
        {!editing && (
          <button onClick={abrir} className="text-xs px-3 py-1 rounded-lg border border-indigo-300 text-indigo-700 hover:bg-indigo-100" data-testid="editar-padres-btn">
            {tiene ? 'Editar padres' : 'Asignar padres'}
          </button>
        )}
      </div>
      {!editing && !tiene && <p className="text-xs text-indigo-700">Sin madre ni padre registrados.</p>}
      {!editing && tiene && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {animal.madre_id && <GenealogyCard label="Madre" animalId={animal.madre_id} navigate={navigate} />}
          {animal.padre_id && <GenealogyCard label="Padre" animalId={animal.padre_id} navigate={navigate} />}
          {!animal.padre_id && animal.padre_externo && (
            <div className="bg-white rounded-lg p-3 border border-indigo-100" data-testid="genealogia-padre-externo">
              <p className="text-xs text-indigo-600 font-semibold mb-1">Padre (externo / semen)</p>
              <p className="font-bold text-gray-900">{animal.padre_externo}</p>
              <p className="text-xs text-gray-500">Toro no registrado en el establecimiento (IATF / servicio externo)</p>
            </div>
          )}
        </div>
      )}
      {editing && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="editar-padres-form">
          <div>
            <label className="block text-xs text-indigo-800 mb-1">Madre (VID o chip)</label>
            <input value={madreVid} onChange={e => setMadreVid(e.target.value)} placeholder={animal.madre_id ? 'Dejar vacio para quitar' : 'Ej: 2001'} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="madre-vid-input" />
          </div>
          <div>
            <label className="block text-xs text-indigo-800 mb-1">Padre (VID del toro o codigo de semen)</label>
            <input value={padreVid} onChange={e => setPadreVid(e.target.value)} placeholder="Ej: 5001 o BO414" className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="padre-vid-input" />
            <p className="text-[11px] text-indigo-600 mt-1">Si el VID no es un toro tuyo, se guarda como padre externo (IATF).</p>
          </div>
          {error && <p className="sm:col-span-2 text-xs text-red-600" data-testid="editar-padres-error">{error}</p>}
          <div className="sm:col-span-2 flex gap-2">
            <button onClick={guardar} disabled={saving} className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700 disabled:opacity-50" data-testid="guardar-padres-btn">{saving ? 'Guardando...' : 'Guardar'}</button>
            <button onClick={() => setEditing(false)} className="px-4 py-2 border rounded-lg text-sm" data-testid="cancelar-padres-btn">Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};
